import { useEffect, useRef, useState } from 'react'
import { phoneFormat } from '../../../lib/script';

import classes from './InputBox.module.css'

const InputBoxLogin = ({label, type, name, required, placeholder, icon, passView, currentValue, action, identifier, maxWidth, minWidth, format, maxNumericValue, autocomplete, isNotModifiable, setStyle}) => {
    const inputRef = useRef(null);
    const [isfocused, setIsFocused] = useState(false)
    const [showPassword, setShowPassword] = useState(false);

    const [defaultValue, setDefaultValue] = useState(currentValue ? currentValue : '')

    const foucsHandler = () => {
        setIsFocused(true)
    }

    const blurHandler = (e) => {
        if (e.target.value == '') {
            setIsFocused(false)
        }    
        
        if (e.target.value && action && e.target.value !== currentValue) {
            action({
                data: {
                    value: e.target.value
                },
                identifier: identifier
            })
        }
    }


    const clearInputHandler = () => {
        inputRef.current.value = "";
        setDefaultValue('')
        setIsFocused(false)

        if (action) {
            action({
                data: {
                    value: null
                },
                identifier: identifier
            })
        }
    }

    const viewPasswordHandler = () => {
        setShowPassword(prevState => prevState = !prevState)
    }

    useEffect(() => {
        setDefaultValue(currentValue ? currentValue : '')
        if (currentValue) {
            setIsFocused(true)
        }
    }, [currentValue])

    useEffect(() => {
        const checkAutofilled = () => {
            const autofilled = !!document.getElementById(name)?.matches('*:-webkit-autofill')

            setIsFocused(autofilled)
        }


        setTimeout(checkAutofilled, 500)
        setTimeout(checkAutofilled, 1000)
        // setTimeout(checkAutofilled, 2000)
    }, [])


    const handleKeyDown = (event) => {
        if (event.key == 'Enter') {
            setDefaultValue(event.target.value)
            if (event.target.value && action) {
                action({
                    data: {
                        value: event.target.value
                    },
                    identifier: identifier
                })
            }
        }
    }

    const keyuphandler = (event) => {
       
        if (format && format == 'phone') {
            const numericValue = event.target.value.replace(/[^0-9]/g, "");

            if (numericValue) {
                setDefaultValue(phoneFormat(numericValue))  
            }
        } else if (format && format == '100max') {
            const numericValue = event.target.value.replace(/[^0-9]/g, "");
            if (maxNumericValue) {
                if (numericValue > maxNumericValue) {
                    setDefaultValue(100)
                } else {
                    setDefaultValue(numericValue.slice(0,3))
                }
            } else {
                setDefaultValue(numericValue.slice(0,3))
            }
            
        } else if (format && format == 'curency') {
            setDefaultValue(event.target.value)
        } else {
            setDefaultValue(event.target.value)
        }
    }

    return <div className={`${classes.input_box} ${setStyle ? classes[setStyle] : ''}`} style={{maxWidth: maxWidth, minWidth: minWidth}}>

        {icon && <div className={classes.input_box_icon}><i className={icon}></i></div>}
        <div className={`${classes.input_box_fields} ${isfocused && classes.focused}`}>
            <label htmlFor={name} className={classes.label}>{label}</label>

            <input autoComplete="off" ref={inputRef} className={classes.input}  type={!showPassword ? type : 'text'} name={name} id={name} required={required} placeholder={placeholder} onFocus={foucsHandler} onBlur={blurHandler} onChange={keyuphandler} onKeyDown={handleKeyDown} value={defaultValue} disabled={isNotModifiable}/>
            {!isNotModifiable && <button className={classes.clear_input} type='button' onClick={clearInputHandler}>
                <i className='ti ti-x'></i>
                <span className='sr-only'>clear input</span>
            </button>}
            {passView && <button onClick={viewPasswordHandler} className={classes.show_pass} type='button'>
                <i className='ti ti-eye'></i>
                <span className='sr-only'>show password</span>
            </button>}
        </div>
    </div>
}

export default InputBoxLogin